import { Dropdown } from 'bootstrap';

let boostrapFix = {
    init: () => {

        // Dropdonw fix
        const dropdownButtons = document.querySelectorAll('.easyflow-dropdown-toggle');
        dropdownButtons.forEach(dropdown => {
            // Reinitialize dropdowns using Bootstrap's JavaScript interface
          var dropdownInstance = Dropdown.getOrCreateInstance(dropdown);

          dropdown.addEventListener('click', function(event) {
            event.stopPropagation(); // Prevent the event from bubbling up
            dropdownInstance.toggle();
          });

        });
    },
}
export default boostrapFix;